"use client";

import { useTranslatedSize } from "@/features/cart/CartItem";
import { useTranslations } from "@/i18n/client";
import { useQueryParams } from "@frend-digital/ui/next";
import { Suspense } from "react";
import { SectionTitle } from "./ProductSection";

const UnsuspendedSelectedProductSize = () => {
	const t = useTranslations("product.detail");
	const params = useQueryParams();

	const selectedSize = useTranslatedSize(params.get("size") ?? "");

	if (selectedSize) return <SectionTitle name={t("size")}>{selectedSize}</SectionTitle>;
};

export const SelectedProductSize = () => {
	return (
		<Suspense fallback={null}>
			<UnsuspendedSelectedProductSize />
		</Suspense>
	);
};
